import React from 'react';
import { createPortal } from 'react-dom';

type CreateModalProps = {
  children: JSX.Element | JSX.Element[] | React.ReactNode;
  selector: string;
  open: boolean;
};

export default function CreateModal({ children, selector, open }: CreateModalProps) {
  const [isDoc, setIsDoc] = React.useState(false);

  React.useEffect(() => {
    setIsDoc(true);
    return () => setIsDoc(false);
  }, [isDoc, setIsDoc, open, selector]);

  if (!isDoc) return null;
  const elm = document.querySelector(selector);

  return elm && open && isDoc ? createPortal(children, elm) : null;
}
